import { Listing, MapListing } from '@kamernet/core/ApiClient/Kamernet';

export function transformMapListingsToListings(
  mapListings: MapListing[] | null,
): Listing[] {
  if (!mapListings) {
    return [];
  }

  return mapListings.map(mapListing => ({
    listingId: mapListing.listingId,
    thumbnailUrl: mapListing.thumbnailUrl || '',
    fullPreviewImageUrl: mapListing.thumbnailUrl || '',
    isTopAdvert: mapListing.hasMoveUp,
    isReactForFree: mapListing.reactForFree,
    furnishingId: mapListing.furnishingId,
    availabilityEndDate: mapListing.availabilityEndDate,
    availabilityStartDate: mapListing.availabilityStartDate,
    street: mapListing.streetName,
    streetSlug: mapListing.streetSlug,
    city: mapListing.cityName,
    citySlug: mapListing.citySlug,
    isFavorite: mapListing.isFavorite,
    surfaceArea: mapListing.surface,
    listingType: mapListing.listingType,
    totalRentalPrice: mapListing.price,
    utilitiesIncluded: false,
    isNewAdvert: false,
    isStudentHouseAdvert: mapListing.isStudentHouseAdvert,
    studentHouseId: mapListing.studentHouseId,
  }));
}
